const Parse = require('parse');

class ParseHelper 
{
    WebsiteTableName = "RailNLWebsites";
  
    constructor(){
        Parse.initialize("SwecoRailPortal","ejmTIziMnC2WiIBlnpOrGhesmXCGwcKX");
        Parse.serverURL = 'https://rail-nl.app/parse';
    }

    Logout() {
        Parse.User.logOut();
    }

    GetSites() {
        const sites = Parse.Object.extend(this.WebsiteTableName);
        const query = new Parse.Query(sites);   
        return query.find();
    }

    AddNewSite(name, props) {
        const siteTable = Parse.Object.extend(this.WebsiteTableName);
        const site = new siteTable();
        var siteData = {
            siteName : name,
            sitedescription : props.description,
            siteUrl : props.url,
            siteLogo : props.logo,
            siteStatus : props.status,
            siteTags : props.tags,
            externalSite : props.externalSite,
        };
      
        return site.save(siteData);
    }
    
    UpdateSite(id, updatedData) {
        const sites = Parse.Object.extend(this.WebsiteTableName);
        const query = new Parse.Query(sites);
        
        return query.get(id)
            .then(site => {
                // Update site properties
                site.set('siteName', updatedData.name);
                site.set('sitedescription', updatedData.description);
                site.set('siteUrl', updatedData.url);
                site.set('siteLogo', updatedData.logo);
                site.set('siteStatus', updatedData.status);
                site.set('siteTags', updatedData.tags);
                site.set('externalSite', updatedData.externalSite);
                
                return site.save();
            });
    }
    
    DeleteSite(id) {
        const sites = Parse.Object.extend(this.WebsiteTableName);
        const query = new Parse.Query(sites);
        
        return query.get(id)
            .then(site => {
                return site.destroy();
            });
    }
}

const parseHelperInstance = new ParseHelper();
export default parseHelperInstance;
